import deepmerge from 'deepmerge';

import TR from '../../bluestone/TR';
import deprecatedColors from '../../cobalt/colors/deprecated';
import derivedColors from '../../cobalt/colors/derived/TR';
import type { Colors } from '../../types';
import baseColors from './base/TR';

const colors: Colors = {
  ...TR.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.primary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
